import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    // TableContainer,
    // Paper,
    // Table,
    // TableHead,
    // TableRow,
    // TableCell,
    // TableBody,
    Grid,
    Button,
    DialogProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
    // IconButton
} from '@material-ui/core';
// import VisibilitySharpIcon from '@material-ui/icons/VisibilitySharp';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { SupportRequest, SupportRequestTypes } from 'src/reducers/supportRequest';
import MaterialTable, { Column } from 'material-table';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { CSVLink } from 'react-csv';
import { SupportExportTickets } from 'src/reducers/support';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { commonDateFormat } from 'src/actions/completedOrderDateAction';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Rating from '@material-ui/lab/Rating';

interface TableState {
    columns: Array<Column<SupportRequest>>;
    data: SupportRequest[];
}
export interface SupportRequestPageProps {
    onRowClick: (orderid: string, rowData: string) => void;
    goSupportPage: () => void;
    saveLoading: (search: boolean) => void;
    goSupportChat: (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => void;
    supportRequest: SupportRequest[];
    supportRequestTypes: SupportRequestTypes[];
    session: string;
    username: string;
    apiUrl: string;
    goToFeedback: (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 500,
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        flexCon: {
            display: 'flex'
        },
        color: {
            '&:hover': {
                backgroundColor: '#23a710e6',
                color: '#fff'
            }
        },
        linkColor: {
            'color': theme.palette.primary.main,
            'cursor': 'pointer',
            '&:hover': {
                color: '#bababa'
            }
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            fontStyle: 'italic',
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
            color: 'green',
            cursor: 'pointer'
        },
    })
);

// function createData(ticketNo: string, date: string, supportType: string, status: string) {
//     return { ticketNo, date, supportType, status };
// }

// const rows = [
//     createData('TKT0001', '17-April', 'Case Status', 'open'),
//     createData('TKT0002', '18-April', 'Payment Related', 'Closed'),
//     createData('TKT0003', '19-April', 'Portal Status', 'Closed'),
// ];

export const SupportRequestPage: React.StatelessComponent<SupportRequestPageProps> = (props) => {
    const classes = useStyles({});
    const csvLinkEl = React.useRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>(null);
    const [exportData, setExportData] = React.useState<SupportExportTickets[]>([]);
    const [fdate, setFdate] = React.useState<Date>(new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)));
    const [tdate, setTdate] = React.useState<Date>(new Date());

    const [dialogOpen, setdialogOpen] = React.useState(false);
    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('sm');

    const closeFilter = () => {
        setdialogOpen(false);
    };

    // const supportType = ['NaN', 'Cancel Order', 'Re-Design Request', 'Quality Concern', 'Billing / Payment', 'Portal Related', 'Others'];

    // const getSupportType = (spType: string) => {
    //     const supportType = props.supportRequestTypes.filter((item) => item.rowno === spType);
    //     if (supportType.length > 0) {
    //         return supportType[0].mt_name;
    //     }
    //     return '-';
    // };

    // const maxDayCount = (sdate: Date, edate: Date) => {
    //     if (Math.abs(sdate.getTime() - edate.getTime()) < (8 * 24 * 60 * 60 * 1000)) {
    //         return false;
    //     }
    //     return true;
    // };

    const changeFDate = (changeDate: Date) => {
        setFdate(changeDate);
    };

    const changeTDate = (changeDate: Date) => {
        setTdate(changeDate);
    };

    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Ticket No',
                field: 'ticketno',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                },
                render: rowData => (
                    <div className={classes.flexCon}>
                        <div
                            className={classes.linkColor}
                            onClick={(e) => props.goSupportChat(rowData.ticketno, rowData.createdon, rowData.supporttype, rowData.status, rowData.mtype, rowData.caseno)}
                        >
                            {rowData.ticketno}
                        </div>
                        {
                            rowData.tstatus === -1 && 
                                <div
                                    onClick={() => props.goToFeedback(rowData.ticketno, rowData.createdon, rowData.supporttype, rowData.status, rowData.mtype, rowData.caseno)}
                                    aria-label="feedback"
                                    className={classes.qcreq}
                                >
                                    Feedback
                                </div>
                        }
                        {
                            Number(rowData.tstatus) > 0 && 
                            <Rating
                                name="feedback-rating"
                                value={rowData.tstatus}
                                readOnly
                                precision={1}
                                size="small"
                                className={classes.rating_In}
                                style={{width: '100%', fontSize: '10px', justifyContent: 'flex-end'}}
                            />
                        }
                    </div>
                )
            },
            {
                title: 'Date',
                field: 'createdon',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Support Type',
                field: 'mtype',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Order Id',
                field: 'caseno',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                },
                render: rowData => (
                    <div className={classes.linkColor} onClick={(e) => props.onRowClick(rowData.caseno, rowData.dsorderid)}>{rowData.caseno}
                    </div>
                )
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '5px 10px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Filename',
                field: 'fname',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Status',
                field: 'status',
                filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                },
                render: rowData => (
                    <div>
                        {rowData.status === '0' ? <div>Open</div> : (rowData.status === '1' ? <div>Closed</div> : <div>Re-Open</div>)}
                    </div>
                )
            },
            {
                title: 'Responded On',
                field: 'respondon',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                }
            },
            {
                title: 'Closed On',
                field: 'closedon',
                // filtering: false,
                cellStyle: {
                    padding: '10px 10px',
                    fontSize: '12px'
                }
            }
        ],
        data: props.supportRequest
    });

    const tableHeaders = [
        { label: 'S. No', key: 'rowno' },
        { label: 'Order No', key: 'caseno' },
        // { label: 'Booking ID', key: 'refno' },
        { label: 'Filename', key: 'fname' },
        { label: 'Ticket No', key: 'ticketno' },
        { label: 'Ticket Raised Date and Time', key: 'createdon' },
        { label: 'Support Type', key: 'mtype' },
        { label: 'Remarks by the Customer', key: 'remarks' },
        { label: '1st Response Date and Time', key: 'respondon' },
        { label: 'Ticket Status', key: 'tstatus' },
        { label: 'Ticket Closure Date and Time', key: 'closedon' },
        { label: 'Feedback, if shared', key: 'fbremarks' },
    ];

    const exportSupportTickets = () => {
        props.saveLoading(true);
        axios({
            method: 'post',
            url: `${props.apiUrl}getSupportTicketData?listType=tktsexp&userCode=${encodeURIComponent(props.username)}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: props.session || ''
            },
            data: {
                fdate: commonDateFormat(fdate, 'date'),
                tdate: commonDateFormat(tdate, 'date')
            }
        }).then(async function (response: AxiosResponse) {
            setExportData(response.data);
            if (csvLinkEl && csvLinkEl.current && response.data.length > 0 && response.data[0].status !== '') {
                csvLinkEl.current.link.click();
            }
            props.saveLoading(false);
        }).catch(function (error: AxiosError) {
            console.error(error);
            props.saveLoading(false);
        });
    };

    const submitFilter = () => {
        exportSupportTickets();
        setdialogOpen(false);
    };

    return (
        <div className={classes.root}>
            <Grid container justify="flex-end" spacing={2}>
                <Grid item>
                    <Button
                        variant="contained"
                        className={classes.color}
                        color="primary"
                        size="small"
                        onClick={() => props.goSupportPage()}
                        startIcon={<AddCircleOutlineRoundedIcon />}
                    >
                        Create New
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        className={classes.color}
                        color="primary"
                        size="small"
                        onClick={() => submitFilter()}
                        startIcon={<FileCopyIcon />}
                    >
                        Export
                    </Button>
                </Grid>
            </Grid>
            <Dialog
                open={dialogOpen}
                onClose={closeFilter}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                <DialogTitle id="alert-dialog-title"><Typography variant="h6" style={{ textAlign: 'left', fontWeight: 'bold' }}>Export Tickets: </Typography></DialogTitle>
                <DialogContent dividers>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <div className={classes.dialog}>
                            <Grid container justify="space-around" spacing={2}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog"
                                    label="Start Date"
                                    format="MM/dd/yyyy"
                                    value={fdate}
                                    onChange={changeFDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="date-picker-dialog-2"
                                    label="End Date"
                                    // helperText={dayValidation && 'Data not more than a week'}
                                    format="MM/dd/yyyy"
                                    value={tdate}
                                    onChange={changeTDate}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </Grid>
                        </div>
                    </MuiPickersUtilsProvider>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="button"
                        color="primary"
                        className={classes.HeadinG}
                        onClick={() => submitFilter()}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            <CSVLink
                headers={tableHeaders}
                filename={`Support_Tickets_${fdate.toLocaleDateString()}_${tdate.toLocaleDateString()}`}
                data={exportData}
                ref={csvLinkEl}
            />
            <br />
            <MaterialTable
                title="Support Requests"
                columns={state.columns}
                data={props.supportRequest}
                // localization={{
                //     header: {
                //         actions: 'View'
                //     }
                // }}
                options={{
                    // filtering: true,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    sorting: true,
                    actionsColumnIndex: -1,
                    headerStyle: {
                        backgroundColor: '#757575',
                        color: '#fff',
                        padding: '5px 10px',
                    }
                }}
                actions={[
                    // {
                    //     icon: 'chevron_right',
                    //     tooltip: 'View',
                    //     onClick: (event, rowData) => {
                    //         // ==> console.error(rowData);
                    //         const ticketno = JSON.parse(JSON.stringify(rowData)).ticketno;
                    //         const date = JSON.parse(JSON.stringify(rowData)).createdon;
                    //         const supporttype = JSON.parse(JSON.stringify(rowData)).supporttype;
                    //         const status = JSON.parse(JSON.stringify(rowData)).status;
                    //         props.goSupportChat(ticketno, date, supporttype, status);
                    //         // props.onFileName(JSON.parse(JSON.stringify(rowData)).filename)
                    //         // alert(`You saved ${rowData[`orderno`]}`);
                    //     }
                    // },
                    // {
                    //     icon: 'chevron_right',
                    //     tooltip: 'view',
                    //     onClick: (event, rowData) => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))
                    // }
                ]}
            />
            {/* <TableContainer component={Paper}>
                <Table className={classes.table} size="small" stickyHeader aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Ticket No</TableCell>
                            <TableCell align="left">Date</TableCell>
                            <TableCell align="left">Support Type</TableCell>
                            <TableCell align="left">Status</TableCell>
                            <TableCell align="left">View</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.supportRequest.map((supportData, index) => (
                            <TableRow hover key={index}>
                                <TableCell>
                                    {supportData.ticketno}
                                </TableCell>
                                <TableCell>
                                    {supportData.createdon}
                                </TableCell>
                                <TableCell>
                                    {supportType[parseInt(supportData.supporttype, 10)]}
                                </TableCell>
                                <TableCell>
                                    {supportData.status === '0' ? 'Open' : 'Closed'}
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={() => { props.goSupportChat(supportData.ticketno, supportData.createdon, supportData.supporttype, supportData.status); }}
                                        // id={JSON.stringify(useraccount)}
                                        // value={useraccount.pusername}
                                        color="primary"
                                        aria-label="edit"
                                        className={classes.iconbutton}
                                    >
                                        <VisibilitySharpIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> */}
        </div>
    );
};

export default SupportRequestPage;



// WEBPACK FOOTER //
// ./src/components/layouts/SupportRequestView.tsx